/* eslint-disable no-undef */
import React from 'react';
import Main from './componets/Main'
import Header from './componets/Header';
import './App.css';
import './css/Fade.css';

const App = () => {
  return (
    <div>
      <Header/>
      <Main/>
    </div>
  );
}

export default App;
